"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { inputs } from "./inputs.builder";

const ReassuranceBanner = dynamic(async () => (await import("./ReassuranceBanner")).ReassuranceBanner);

export const ReassuranceBannerComponent: RegisteredComponent = {
  name: "ReassuranceBanner",
  component: ReassuranceBanner,
  inputs,
};
